// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConceptDetail_concept-detail__uaxZB {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.ConceptDetail_concept-detail__uaxZB > *:not(:last-child) {
  border-bottom: 1px solid var(--light-grey);
}
.ConceptDetail_concept-detail__uaxZB .ConceptDetail_concept-detail--body__mG-ID {
  display: flex !important;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 30px;
  padding: 25px;
}
.ConceptDetail_concept-detail__uaxZB .ConceptDetail_concept-detail--body__mG-ID .ConceptDetail_keyword-cloud__IGqVu {
  border: 1px var(--light-blue) solid;
  border-radius: 12px;
  padding: 16px;
}
@media only screen and (max-width: 480px) {
  .ConceptDetail_concept-detail__uaxZB .ConceptDetail_concept-detail--body__mG-ID {
    padding: 16px;
  }
  .ConceptDetail_concept-detail__uaxZB .ConceptDetail_concept-detail--body__mG-ID .ConceptDetail_keyword-cloud__IGqVu {
    border: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/ConceptDetail/ConceptDetail.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;AACE;EACE,0CAAA;AACJ;AAGI;EACE,wBAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;AADN;AAGM;EACE,mCAAA;EACA,mBAAA;EACA,aAAA;AADR;AAME;EACE;IACE,aAAA;EAJJ;EAMI;IACE,YAAA;EAJN;AACF","sourcesContent":[".concept-detail {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n\n  > *:not(:last-child) {\n    border-bottom: 1px solid var(--light-grey);\n  }\n\n  .concept-detail {\n    &--body {\n      display: flex !important;\n      flex-direction: column;\n      gap: 24px;\n      margin-bottom: 30px;\n      padding: 25px;\n\n      .keyword-cloud {\n        border: 1px var(--light-blue) solid;\n        border-radius: 12px;\n        padding: 16px;\n      }\n    }\n  }\n\n  @media only screen and (max-width: 480px) {\n    .concept-detail--body {\n      padding: 16px;\n\n      .keyword-cloud {\n        border: none;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"concept-detail": `ConceptDetail_concept-detail__uaxZB`,
	"concept-detail--body": `ConceptDetail_concept-detail--body__mG-ID`,
	"keyword-cloud": `ConceptDetail_keyword-cloud__IGqVu`
};
export default ___CSS_LOADER_EXPORT___;
